export const roleList = [
    {
        level: 0,
        name: '超级管理员'
    },
    {
        level: 1,
        name: '业务经理'
    },
    {
        level: 2,
        name: '采购商'
    },
    {
        level: 3,
        name: '供应商'
    }
];
